import { render, staticRenderFns } from "./PopupCopyComponentForm.vue?vue&type=template&id=3a1cdd77"
import script from "./PopupCopyComponentForm.vue?vue&type=script&lang=js"
export * from "./PopupCopyComponentForm.vue?vue&type=script&lang=js"
import style0 from "./PopupCopyComponentForm.vue?vue&type=style&index=0&id=3a1cdd77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports